module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Time course"},"de":{"title":"Zeitlicher Verlauf"},"fr":{"title":"Cours du temps"},"it":{"title":"Corso a tempo"}}')
  delete Component.options._Ctor
}
